import { AppStorage } from '@/core/utils/app.storage';
import { AppStorageService } from '@/core/utils/app.storage.service';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { from, mergeMap, of } from 'rxjs';

export const authGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const appStorageService = inject(AppStorageService);

  return from(appStorageService.get<string>(AppStorage.SESSION)).pipe(
    mergeMap((sessionToken) => {
      if (sessionToken && sessionToken != null && sessionToken !== 'null') {
        if (state.url.indexOf('inicio-sesion') > -1) {
          router.navigate(['/']);
          return of(false);
        } else {
          return of(true);
        }
      } else {
        if (state.url.indexOf('inicio-sesion') > -1 || state.url.indexOf('registro') > -1) {
          return of(true);
        } else {
          router.navigate(['/inicio-sesion']);
          return of(false);
        }
      }
    }),
  );
};
